import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  class: "card-title bg-success-600 text-white",
  style: {"padding":"8px"}
}
const _hoisted_4 = {
  id: "js_demo_accordion-2a",
  class: "collapse show",
  "data-parent": "#js_demo_accordion-2"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { id: "tableflame" }
const _hoisted_7 = {
  class: "table table-sm table-bordered m-0",
  id: "tableDailyReport"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_tableReportList_det = _resolveComponent("Mo_tableReportList_det")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary waves-effect waves-themed mr-1 btn-det",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('/dailyReportEdit?id=' + _ctx.item.c_report_id, $event)))
        }, " 詳細 "),
        _createTextVNode(" " + _toDisplayString(_ctx.item.c_report_date_str) + "　" + _toDisplayString(_ctx.item.c_staff_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "cwC_1" }, [
                  _createTextVNode("種別"),
                  _createElementVNode("br"),
                  _createTextVNode("（決定、提案、調査）")
                ]),
                _createElementVNode("th", { class: "cwC_2" }, "案件名"),
                _createElementVNode("th", { class: "cwC_3" }, "商談先"),
                _createElementVNode("th", { class: "cwC_4" }, "場所"),
                _createElementVNode("th", { class: "cwC_5" }, "内容"),
                _createElementVNode("th", { class: "cwC_6" }, "売上"),
                _createElementVNode("th", { class: "cwC_7" }, "仕入")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.c_report_det_row, (row) => {
                return (_openBlock(), _createBlock(_component_Mo_tableReportList_det, {
                  key: row.c_report_det_rownum!,
                  item: row
                }, null, 8, ["item"]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("textarea", {
            name: "txtComment",
            class: "form-control txtComment",
            disabled: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.cnvRemarks) = $event))
          }, null, 512), [
            [_vModelText, _ctx.item.cnvRemarks]
          ])
        ])
      ])
    ])
  ]))
}